import {
  IOfferingRes,
  IQuoteItemReqSchema,
  IQuoteOfferingRespSchema,
  SelectedProductsWithinOfferingForm,
} from '@monetize/types/app';
import { MButton } from '../../../../../../components/Monetize';
import { ManageProductsModal } from './ManageProductsModal';

interface IManageProductsProps {
  offering?: IOfferingRes | null;
  quoteItems: IQuoteItemReqSchema[];
  quoteOffering?: IQuoteOfferingRespSchema | null;
  watchRateId?: string | null;
  isManageProductDisabled: boolean;
  updateOfferingItems: (
    offering: SelectedProductsWithinOfferingForm,
  ) => Promise<void>;
  modalConfig: {
    isOpen: boolean;
    onClose: () => void;
    onDrawerClose: () => void;
    onDrawerOpen: () => void;
  };
  setDrawerOpen: (value: boolean) => void;
  disableOneTimeProducts?: boolean;
}

export const ManageProducts = ({
  offering,
  quoteItems,
  quoteOffering,
  watchRateId,
  isManageProductDisabled,
  modalConfig,
  updateOfferingItems,
  setDrawerOpen,
  disableOneTimeProducts,
}: IManageProductsProps) => {
  const { isOpen, onClose, onDrawerClose, onDrawerOpen } = modalConfig;

  const handleClose = () => {
    onDrawerClose();
    onClose();
  };

  const handleOpen = () => {
    onDrawerOpen();
    setDrawerOpen(true);
  };

  if ((quoteItems && !quoteItems?.length) || !offering?.offeringProducts) {
    return null;
  }

  return (
    <>
      {/* if all products are mandatory do not show this button */}
      {watchRateId && (
        <MButton
          variant="tertiary"
          onClick={handleOpen}
          isDisabled={isManageProductDisabled}
        >
          Manage Products ({quoteItems?.length}/
          {offering?.offeringProducts.length})
        </MButton>
      )}
      {isOpen && offering && (
        <ManageProductsModal
          offering={offering}
          quoteItems={quoteItems}
          onSave={updateOfferingItems}
          onClose={handleClose}
          quoteOffering={quoteOffering}
          disableOneTimeProducts={disableOneTimeProducts}
        />
      )}
    </>
  );
};
